// Cloudflare Turnstile, for a room that asks a new llama to prove it is a
// person. The script loads only when a room asks.

const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';

interface TurnstileApi {
  render: (
    holder: HTMLElement,
    options: { sitekey: string; callback: (token: string) => void },
  ) => string | undefined;
}

let loading: Promise<TurnstileApi> | null = null;

function loadTurnstile(): Promise<TurnstileApi> {
  loading ??= new Promise<TurnstileApi>((done, fail) => {
    const script = document.createElement('script');
    script.src = SCRIPT_URL;
    script.async = true;
    script.onload = () => {
      const api = (window as unknown as { turnstile?: TurnstileApi }).turnstile;
      if (api) done(api);
      else fail(new Error('Turnstile did not load.'));
    };
    script.onerror = () => fail(new Error('Turnstile did not load.'));
    document.head.append(script);
  }).catch((error: unknown) => {
    // The next challenge tries the script again.
    loading = null;
    throw error;
  });
  return loading;
}

// Puts the widget in `holder`. Managed mode: most people see a check mark and
// nothing to do. `onToken` gets the proof to send to the room.
export function showTurnstile(
  holder: HTMLElement,
  siteKey: string,
  onToken: (token: string) => void,
): void {
  loadTurnstile()
    .then((api) => api.render(holder, { sitekey: siteKey, callback: onToken }))
    .catch(() => holder.replaceChildren());
}
